/*
 * @Author: heyuan
 * @Date: 2020-08-19 16:41:57
 * @LastEditors: heyuan
 * @LastEditTime: 2020-08-19 17:44:26
 * @FilePath: \program-name\src\net\home\index.js
 */
import {get,post} from "../Api.js";
import config from "../config";
import {getCookie} from '../../untils/common.js'
import axios from 'axios'
const {baseUrl} = config

// 竞赛，竞赛详情
function ApiGetInfo (params) {
  return get(`${baseUrl}competition/info`, params);
}

// 竞赛，个人活动排名总计
function ApiGetMyScore (params) {
  return get(`${baseUrl}competition/myActivityScore`, params);
}
// 竞赛，个人活动排行榜
function ApiGetActivityScoreRank (params) {
  return post(`${baseUrl}competition/activityScoreRank`, params);
}
// 竞赛，竞赛活动团队总计
function ApiGetMyTeamScore (params) {
  return get(`${baseUrl}competition/myTeamScore`, params);
}
// 竞赛，竞赛团队排行榜
function ApiGetTeamScoreRank (params) {
  return post(`${baseUrl}competition/teamScoreRank`, params);
}
// 获取竞赛试题 (h5)
function ApiGetQuestion(params) {
  return post(`${baseUrl}competition/question`, params);
}
// 提交竞赛答案 (h5)
function ApiAnswer(params) {
  return post(`${baseUrl}competition/answer`, params);
}
// 获取本次竞赛答题结果
function ApiGetResult(params) {
  return get(`${baseUrl}competition/result`, params);
}
// 清空竞赛试题code
function ApiClearCode(params) {
  return post(`${baseUrl}competition/clearCode`, params);
}
// 获取部门名
function ApiGetDepartment(params) {
  return get(`${baseUrl}student/department`, params);
}
export {
  ApiGetInfo,
	ApiGetMyScore,
  ApiGetActivityScoreRank,
  ApiGetMyTeamScore,
  ApiGetTeamScoreRank,
  ApiGetQuestion,
  ApiAnswer,
	ApiGetResult,
  ApiClearCode,
  ApiGetDepartment
}



// WEBPACK FOOTER //
// ./src/net/cdjs/index.js